var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.installationSummaryStatus, function(installationStatusData) {
      return _c(
        "span",
        { staticStyle: { padding: "8px", "font-weight": "700" } },
        [
          _vm._v(
            "\n    " +
              _vm._s(installationStatusData.name) +
              ": " +
              _vm._s(installationStatusData.total) +
              "#;\n    " +
              _vm._s(installationStatusData.percentageOfTotal) +
              "%;\n    " +
              _vm._s(_vm.format(installationStatusData.totalInjection)) +
              "kWh;\n    " +
              _vm._s(installationStatusData.percentageInjectionOfTotal) +
              "% |\n  "
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }